<template>
  <div class="regional-alarm-infos">
    <div class="regional-alarm-infos__header">
      <span class="regional-alarm-infos__regional-name">
        {{ regional.name }}
      </span>
      <hr class="regional-alarm-infos__line">
    </div>
    <div
      v-for="installation in regional.installations"
      :key="installation.installationId"
    >
      <installation-alarm-panel
        :installation="installation"
        :filter="filter"
        :expanded-installation="expandedInstallation"
        @recognize-alarm="onRecognizeAlarm"
        @on-collapse-change="onInstallationCollapseChange"
      />
    </div>
  </div>
</template>

<script>
import InstallationAlarmPanel from './InstallationAlarmPanel';

export default {
  components: { InstallationAlarmPanel },
  props: {
    regional: {
      type: Object,
      default: () => ({}),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      expandedInstallation: '',
    };
  },
  methods: {
    onRecognizeAlarm() {
      this.$emit('recognize-alarm');
    },
    onInstallationCollapseChange(options) {
      if (!options.value) {
        this.expandedInstallation = options.installation;
        return;
      }
      this.expandedInstallation = '';
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  .regional-alarm-infos
    &__header
      display: flex
    &__line
      border-top: 1px solid $color-gray-medium
      width: 100%
    &__regional-name
      color: $color-gray-medium
      font-weight: bold
      white-space: nowrap
      margin-right: 10px
    ::v-deep
      .accordion-panel
        border: none !important
      .accordion-panel__header
        background-color: var(--color-background-dark) !important
</style>
